export default {"src":"/_next/static/media/google-play.bcf14153.svg","height":102,"width":268};